interface Props {
  percentComplete: number;
}

const SIZE = 72;
const CENTER = SIZE / 2;
const STROKE = 6;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const VIEW_BOX = [0, 0, SIZE, SIZE].join(' ');
// Starts the arc at 12 o'clock. The center (36 36) is SIZE / 2.
const START_AT_TOP = 'rotate(-90 36 36)';

function CourseProgressRing({ percentComplete }: Props) {
  const percent = Math.min(Math.max(percentComplete, 0), 100);
  const filled = (percent / 100) * CIRCUMFERENCE;

  return (
    <div className="relative shrink-0" style={{ width: SIZE, height: SIZE }}>
      <svg width={SIZE} height={SIZE} viewBox={VIEW_BOX} aria-hidden="true">
        <circle
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          className="stroke-gray-200"
          strokeWidth={STROKE}
        />
        <circle
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          className="stroke-primary"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={[filled, CIRCUMFERENCE].join(' ')}
          transform={START_AT_TOP}
        />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-base font-semibold text-gray-900">
        {Math.round(percent)}
        <span className="text-xs font-medium text-gray-500">%</span>
      </span>
    </div>
  );
}

export default CourseProgressRing;
